import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div>
      <h1>Page Not Found or Access Denied</h1>
      <p>
        The page you are looking for doesn't exist or you don't have permission
        to access it.
      </p>
      <button onClick={handleBackToLogin}>Back to Login</button>
    </div>
  );
};

export default NotFoundPage;
